import script from "./checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./checkbox.vue?vue&type=script&setup=true&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=8b25111e&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b25111e"]])

export default __exports__